import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { OEComponents } from '@opportunityeducation/oe-web-common'

import IntendedCourseLevel from '../mini/IntendedCourseLevel'
import QuestIcon from '../mini/QuestIcon'
import PriorityIndicator from '../mini/PriorityIndicator'

import { version } from '../../utils/messages'
import { questIsPublished } from '../../utils/review'
import { getAuthors } from '../../utils/quest'

export default class Header extends Component {
  render() {
    const { quest } = this.props

    return (
      <div id="questHeader">
        {quest.author.split(',').length > 2 && (
          <ReactTooltip
            id="longAuthorsTooltip"
            effect="solid"
            place="bottom"
            offset={{ bottom: 5 }}
          />
        )}
        <ReactTooltip
          id="averageGradeLevelTooltip"
          effect="solid"
          offset={{ right: 20, bottom: 15 }}
        />
        <div className="icon-name-section">
          <QuestIcon
            heightWidth={100}
            icon_image_url={quest.icon_image_url}
            showTypeIcon={Boolean(quest.type.id)}
            questTypeId={quest.type.id}
            questTypeIconSize={34}
          />
          <div className="info-block">
            {!questIsPublished(quest) && quest.mock_course && (
              <IntendedCourseLevel quest={quest} />
            )}
            <h2 className="quest-name">{quest.name}</h2>
            <div className="author-version-updated-container">
              <div
                className="quest-author"
                data-for="longAuthorsTooltip"
                data-tip={quest.author}
              >
                {getAuthors({
                  authors: quest.authors,
                  questId: quest.id
                })}
              </div>
              <div className="version-and-updated">
                <OEComponents.ElapsedTimeFormatter
                  cssClass="elapsed-time"
                  time={quest.updated_at}
                  textBefore="Last saved"
                />
                <span className="interpunct">&bull;</span>
                {version}
                &nbsp;
                {quest.current_version}
                {quest.priority !== 'normal' && (
                  <div
                    style={{
                      marginLeft: '15px',
                      display: 'inline-block',
                      verticalAlign: 'bottom'
                    }}
                  >
                    <PriorityIndicator
                      priority={quest.priority}
                      questId={quest.id}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Header.propTypes = {
  quest: PropTypes.object.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/Header.js